<main class="container-fluid min-vh-100 mb-5">
  <section class="d-flex flex-column align-items-center border bg-second-white">
    <h1 class="text-primary-dark-blue ">Precisa de Ajuda?</h1>
    <p class="subtitle">
      Queremos que o seu negócio cresça cada vez mais. Sempre que precisar de ajuda entre em contato através dos nossos canais de atendimento.
      <b>Segunda à sexta, das 8h às 12h, e das 13h às 17h.</b>
    </p>

    <button
     (click)="openChat()"
      mat-stroked-button class="my-2 p-4"
      class="bg-white p-4"
    >
      <img class="icon" src="assets/images/shared/whatsapp.svg" alt="Ícone do WhatsApp.">
      <span class="text-primary-dark-blue ">Whatsapp</span>
    </button>
  </section>
  <section class="row">
    <section class="col-md-6">
      <mat-card appearance="outlined">
        <mat-card-content class="d-flex align-items-center">
          <mat-icon class="me-4">mail</mat-icon>
          <span>
            <b class="d-block">Podemos te ajudar por email</b>
            <a class="d-block" [href]="'mailto:'+ globalConfig.getEmail()">
              {{ globalConfig.getEmail() }}
            </a>
          </span>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-content class="d-flex align-items-center">
          <mat-icon class="me-4">call</mat-icon>
          <span>
            <b class="d-block">Contato Broadfactor.</b>
            <span class="d-block">{{ globalConfig.getContactNumber().formatted }}</span>
          </span>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-content class="d-flex align-items-center">
          <img class="icon me-4" src="assets/images/shared/whatsapp.svg" alt="Ícone do WhatsApp.">
          <span>
            <b class="d-block">Você pode entrar em contato pelo Whatsapp</b>
            <span class="d-block"><a [href]="globalConfig.getContactNumber().redirectUrl" target="_blank">WhatsApp</a></span>
          </span>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-content class="d-flex align-items-center">
          <mat-icon class="me-4">location_on</mat-icon>
          <span>
            <b class="d-block">Localização</b>
            <span class="d-block">{{ globalConfig.getAddress() }}</span>
          </span>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-content class="d-flex align-items-center">
          <mat-icon class="me-4">quiz</mat-icon>
          <span>
            <b class="d-block">Consulte nossa FAQ com perguntas frequentes</b>
            <span class="d-block"><a  href="/perguntas-frequentes" target="_blank">FAQ</a></span>
          </span>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-content class="d-flex align-items-center">
          <mat-icon class="me-4">web</mat-icon>
          <span>
            <b class="d-block">Consulte nosso BLOG explore artigos financeiros</b>
            <span class="d-block"><a [href]="globalConfig.getBlogBroadfactor()" target="_blank">BLOG</a></span>
          </span>
        </mat-card-content>
      </mat-card>

    </section>
    <figure class="col-md-6 mb-0 d-flex flex-column align-items-center justify-content-center">
      <img
        class="img-contact-us"
        src="assets/images/central-de-ajuda/contact-us.svg"
        alt="Ilustração de uma pessoa segurando uma carta, com ícones de celular e telefone ao redor, representando a central de ajuda e informações de contato."
      >
      <div class="d-flex flex-column align-items-center align-items-center">
        <b class="d-block mb-2 text-center">Nossas redes sociais</b>
        <app-social-media></app-social-media>
      </div>
    </figure>
  </section>
</main>
